import getFiltersOption from '../store/store';
import { mutator } from 'satcheljs';
import { setContactsTrusted } from '../actions/internalActions';

mutator(setContactsTrusted, actionMessage => {
    const filtersOption = getFiltersOption();
    filtersOption.contactsTrusted = actionMessage.contactsTrusted;
});
